import { requestGet } from '../utils/requestApi'

export async function getCompanyList(payload){
  return requestGet('operator', payload)
}
export async function getCompanyGame(payload){
  return requestGet('rankList', payload)
}